module.exports = __webpack_public_path__ + "static/media/vi.0e7c3cbc.png";